import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { OsobaZnaJezik } from './osoba-zna-jezik';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-osoba-zna-jezik-update',
  templateUrl: './osoba-zna-jezik-update.component.html'
})
export class OsobaZnaJezikUpdateComponent
extends BaseUpdateComponent<OsobaZnaJezik>
 implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    // this.addValidatorToFc("Broj", Validators.required, 'required', 'OSOBATELEFON.BROJ.VALIDATION.REQUIRED');
    // this.addValidatorToFc("Broj", Validators.maxLength(20), 'maxlength', 'OSOBATELEFON.BROJ.VALIDATION.MAXLENGTH');
  }

}
